import * as z from 'zod/v4';

/**
 * Event id is used for match id
 */
export const eventIdSchema = z.coerce.number().int().positive().brand<'EventId'>();

/**
 * Branded type for event id.
 */
export type EventId = z.infer<typeof eventIdSchema>;

/**
 * Utility function to create a EventId.
 *
 * @param value input value to check
 * @returns returns true or false if the value matches pattern for event id.
 */
export function isEventId(value: unknown): value is EventId {
  if (typeof value !== 'number') {
    return false;
  }

  if (!Number.isInteger(value)) {
    return false;
  }

  if (value < 1) {
    return false;
  }

  return true;
}

/**
 * Utility function to create a EventId.
 *
 * @param value input value to check
 * @returns Throws error if input dosen't match event id, otherwise returns the event id with branded type.
 * @throws {Error} if input dosen't match event id.
 */
export function getEventId(value: unknown): EventId {
  const isValidEventId = isEventId(value);

  if (!isValidEventId) {
    throw new Error('Invalid EventId');
  }

  return value;
}
